/* POWSTORE Newsletter-Popup – Steuerung (sections/pow-popup.liquid).
   Merkt sich im Browser (localStorage), ob jemand geschlossen oder sich angemeldet hat.
   Meldet Ereignisse an Shopify-Kundenereignisse (für GA4/Pixel): pow_popup_view, pow_popup_submit, pow_popup_close. */
(function () {
  if (customElements.get('pow-popup')) return;

  function readStore(k) { try { return JSON.parse(localStorage.getItem(k)) || {}; } catch (e) { return {}; } }
  function writeStore(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  var editorOpen = false;

  class PowPopup extends HTMLElement {
    connectedCallback() {
      this.dlg = this.querySelector('dialog');
      if (!this.dlg) return;
      this.key = 'pwPopup:' + (this.dataset.key || '1');
      this.state = readStore(this.key);
      this.teaser = this.querySelector('.pw-pop__teaser');
      this.editor = this.hasAttribute('data-editor');
      this.cleanup = [];

      this.addEventListener('click', this.onClick.bind(this));
      this.dlg.addEventListener('close', this.onClose.bind(this));
      var form = this.querySelector('form');
      if (form) form.addEventListener('submit', function () { track('pow_popup_submit', {}); });

      // Öffner im ganzen Shop: data-pw-popup-open oder Links auf #newsletter
      this.onDocClick = (function (e) {
        var t = e.target.closest && e.target.closest('[data-pw-popup-open], a[href$="#newsletter"]');
        if (!t || this.contains(t)) return;
        e.preventDefault();
        this.open('link');
      }).bind(this);
      document.addEventListener('click', this.onDocClick);

      if (this.editor) { this.initEditor(); return; }

      var success = this.querySelector('[data-pw-popup-success]');
      if (success && /[?&]customer_posted=true/.test(location.search)) {
        this.state.subscribed = Date.now(); writeStore(this.key, this.state);
        this.open('success');
        return;
      }
      if (this.querySelector('[data-pw-popup-error]')) { this.open('error'); return; }
      if (location.hash === '#newsletter') { this.open('hash'); return; }
      if (this.state.subscribed || /[?&]popup=0/.test(location.search)) return;

      var days = parseInt(this.dataset.days, 10) || 14;
      if (this.dataset.enabled !== 'true') return;
      if (this.state.closed && Date.now() - this.state.closed < days * 864e5) { this.showTeaser(); return; }
      if (this.dataset.trigger === 'manual') { this.showTeaser(); return; }
      this.arm();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      if (this.onSelect) document.removeEventListener('shopify:section:select', this.onSelect);
      if (this.onDeselect) document.removeEventListener('shopify:section:deselect', this.onDeselect);
      this.disarm();
      document.documentElement.classList.remove('pw-pop-lock');
    }

    initEditor() {
      var self = this;
      var sec = this.closest('.shopify-section');
      var id = sec ? sec.id.replace('shopify-section-', '') : '';
      this.onSelect = function (e) { if (e.detail && e.detail.sectionId === id) { editorOpen = true; self.open('editor'); } };
      this.onDeselect = function (e) { if (e.detail && e.detail.sectionId === id) { editorOpen = false; self.close(); } };
      document.addEventListener('shopify:section:select', this.onSelect);
      document.addEventListener('shopify:section:deselect', this.onDeselect);
      if (editorOpen) this.open('editor');
    }

    arm() {
      var self = this;
      var trig = this.dataset.trigger || 'first';
      var fire = function () { self.disarm(); self.tryOpen(); };
      if (trig === 'first' || trig === 'time') {
        var t = setTimeout(fire, (parseInt(this.dataset.delay, 10) || 15) * 1000);
        this.cleanup.push(function () { clearTimeout(t); });
      }
      if (trig === 'first' || trig === 'scroll') {
        var pct = parseInt(this.dataset.scroll, 10) || 40;
        var onScroll = function () {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h > 0 && (window.scrollY / h) * 100 >= pct) fire();
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        this.cleanup.push(function () { window.removeEventListener('scroll', onScroll); });
      }
      if (this.dataset.exit === 'true' && window.matchMedia('(pointer: fine)').matches) {
        var armedAt = Date.now();
        var onOut = function (e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - armedAt > 4000) fire(); };
        document.addEventListener('mouseout', onOut);
        this.cleanup.push(function () { document.removeEventListener('mouseout', onOut); });
      }
      // Bild kurz vorher laden, damit es beim Öffnen schon da ist
      var img = this.querySelector('.pw-pop__img');
      if (img) {
        var warm = function () { setTimeout(function () { img.loading = 'eager'; }, 2500); };
        if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });
      }
    }

    disarm() { (this.cleanup || []).forEach(function (f) { f(); }); this.cleanup = []; }

    busy() {
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !this.contains(a)) return true;
      if (document.body.style.overflow === 'hidden') return true;
      // Cookie-Banner zuerst entscheiden lassen (16.10.2026)
      var pc = document.getElementById('shopify-pc__banner');
      if (pc && getComputedStyle(pc).display !== 'none' && getComputedStyle(pc).visibility !== 'hidden' && pc.getBoundingClientRect().height > 0) return true;
      return !!document.querySelector('dialog[open]:not(.pw-pop__dlg), .pw-drawer.is-open, cart-drawer.active, details-modal details[open], body.overflow-hidden, body.overflow-hidden-mobile');
    }

    tryOpen() {
      var self = this;
      if (this.busy()) { setTimeout(function () { self.tryOpen(); }, 1000); return; }
      this.open('auto');
    }

    open(reason) {
      if (this.dlg.open) return;
      this.reason = reason;
      this.disarm();
      if (this.teaser) this.teaser.hidden = true;
      var img = this.querySelector('.pw-pop__img');
      if (img) img.loading = 'eager';
      try { this.dlg.showModal(); } catch (e) { this.dlg.setAttribute('open', ''); }
      document.documentElement.classList.add('pw-pop-lock');
      if (reason !== 'editor') track('pow_popup_view', { reason: reason });
    }

    close() { if (this.dlg.open) this.dlg.close(); }

    onClose() {
      document.documentElement.classList.remove('pw-pop-lock');
      if (this.editor) return;
      if (!this.state.subscribed) {
        this.state.closed = Date.now();
        writeStore(this.key, this.state);
        track('pow_popup_close', { reason: this.reason || '' });
        this.showTeaser();
      }
      if (/[?&]customer_posted=true/.test(location.search) && window.history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, ''));
      }
    }

    showTeaser() {
      if (!this.teaser || this.dataset.teaser !== 'true' || this.state.subscribed) return;
      try { if (sessionStorage.getItem('pwPopupTeaserOff')) return; } catch (e) {}
      this.teaser.hidden = false;
    }

    onClick(e) {
      var t = e.target;
      if (t === this.dlg) { this.close(); return; } // Klick auf den abgedunkelten Hintergrund
      if (t.closest('[data-pw-popup-close]')) { e.preventDefault(); this.close(); return; }
      if (t.closest('[data-pw-popup-open]')) { e.preventDefault(); this.open('teaser'); return; }
      if (t.closest('[data-pw-teaser-close]')) {
        this.teaser.hidden = true;
        try { sessionStorage.setItem('pwPopupTeaserOff', '1'); } catch (err) {}
        return;
      }
      var copy = t.closest('[data-pw-copy]');
      if (copy) {
        var code = (this.querySelector('[data-pw-code]') || {}).textContent || '';
        var label = copy.textContent;
        var done = function () { copy.textContent = copy.dataset.done || label; setTimeout(function () { copy.textContent = label; }, 2000); };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code.trim()).then(done, function () {});
        } else {
          var r = document.createRange(); r.selectNodeContents(this.querySelector('[data-pw-code]'));
          var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
          try { document.execCommand('copy'); done(); } catch (err) {}
        }
      }
    }
  }

  customElements.define('pow-popup', PowPopup);
})();
